import {
  Column,
  Copy,
  Heading,
  Row,
  Stack,
} from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { PageSection } from 'src/components/selfService/layout/PageSection/PageSection';
import { useScreenSizes } from 'src/utilities/useScreenSizes';
import { BalanceIllustrationCard } from './BalanceIllustrationCard';
import { MealCreditsImage } from './Images/MealCreditsImage';
import { GroupOrdersImage } from './Images/GroupOrdersImage';
import { MealCreditsAction } from './Actions/MealCreditsAction';
import { GroupOrdersAction } from './Actions/GroupOrdersAction';

const BALANCE_MEAL_CREDITS_TEXT =
  'Give employees meal credits to use when ordering with Grubhub. Edit current meal credits, create new ones, and add or remove people.';
const BALANCE_GROUP_ORDERS_TEXT =
  'Save on delivery fees by placing one shared order for your team. Invite coworkers, let them add their items, then check out for everyone.';

export function BalanceIllustrationContainer(): JSX.Element {
  const { isDesktop } = useScreenSizes();
  const isFullHeight = isDesktop;
  const cardHeight = isFullHeight ? '100%' : undefined;

  return (
    <Row gutter={24} alignItems="stretch">
      <Column tablet={12} desktop={6} gutter={24}>
        <Stack y={isDesktop ? 'none' : 'lg'} height={cardHeight}>
          <PageSection bg="globals.white" fullHeight={isFullHeight}>
            <BalanceIllustrationCard
              illustration={<MealCreditsImage />}
              title={<Heading variant="h3">Meal credits</Heading>}
              description={
                <Copy variant="body">{BALANCE_MEAL_CREDITS_TEXT}</Copy>
              }
              action={<MealCreditsAction />}
            />
          </PageSection>
        </Stack>
      </Column>
      <Column tablet={12} desktop={6} gutter={24}>
        <Stack height={cardHeight}>
          <PageSection bg="globals.white" fullHeight={isFullHeight}>
            <BalanceIllustrationCard
              illustration={<GroupOrdersImage />}
              title={<Heading variant="h3">Group orders</Heading>}
              description={
                <Copy variant="body">{BALANCE_GROUP_ORDERS_TEXT}</Copy>
              }
              action={<GroupOrdersAction />}
            />
          </PageSection>
        </Stack>
      </Column>
    </Row>
  );
}
